import React, { useState, useEffect } from 'react'
import Configurazione from './ConfigurazioneItem'
import Button from '../../../../atoms/Button/Button'
import NewModal from '../../../../molecules/NewModal/NewModal'
import LoadingSvg from '../../../../atoms/Loading/Loading'
import useTrans from '../../../../../hooks/useTrans'
import Zoom from 'react-medium-image-zoom'
import { trackingGAEventProdotto } from '../../../../../utils/gtm'

const ConfigurazioneStampa = ({
  step,
  setStep,
  obj,
  props,
  isPage,
  handleScroll,
  initialValues,
}) => {
  const [ColorError, setColorError] = useState({})
  const [Validate, setValidate] = useState(false)
  const [showPantoni, setShowPantoni] = useState(false)
  const _isValid = () => Object.values(ColorError).includes(true)
  const t = useTrans()

  useEffect(() => {
    setValidate(_isValid())
  }, [])

  useEffect(() => {
    setValidate(_isValid())
  }, [ColorError])

  return (
    <div className="configurazione__stampa">
      {!obj?.tecniche ? (
        <LoadingSvg />
      ) : (
        <>
          {props?.values?.posizioni &&
            props?.values?.posizioni.map((_, index) => (
              <Configurazione
                isPage={isPage}
                key={index}
                index={index}
                obj={obj}
                props={props}
                setColorError={setColorError}
                ColorError={ColorError}
                setShowPantoni={setShowPantoni}
              />
            ))}
        </>
      )}
      {!props.errors.posizioni && !Validate && (
        <Button
          onClick={() => {
            setStep(step + 1)
            handleScroll()
            const first_articolo =
              props?.values?.prodotto?.articoli.length > 0
                ? props?.values?.prodotto?.articoli[0]
                : null
            trackingGAEventProdotto(
              'customization_funnel',
              'c_step2_config_stampa',
              undefined,
              first_articolo?.titolo || '',
              props?.values?.prodotto?.codice || ''
            )
          }}
          label={t('Conferma configurazione')}
          variant="primary"
          size="medium"
        />
      )}
      <NewModal visible={showPantoni} onClose={() => setShowPantoni(false)}>
        <div
          style={{ minHeight: 'fit-content', minWidth: 'fit-content', padding: 20, marginTop: 10 }}
        >
          <Zoom>
            <img src={'/pantone.jpg'} />
          </Zoom>
        </div>
      </NewModal>
    </div>
  )
}

export default ConfigurazioneStampa
